module.exports = __webpack_public_path__ + "static/media/channel-web.cc267ffc.svg";